import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"ListCellMoveCard"}}
export type ListCellMoveCardMutationVariables = Types.Exact<{
  cardId: Types.Scalars['ID'];
  listId: Types.Scalars['ID'];
  traceId?: Types.Maybe<Types.Scalars['String']>;
}>;


export type ListCellMoveCardMutation = (
  { __typename: 'Mutation' }
  & { updateCardList?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'idList'>
  )> }
);


export const ListCellMoveCardDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ListCellMoveCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCardList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idCard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"idList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listId"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idList"}}]}}]}}]};
export type ListCellMoveCardMutationFn = Apollo.MutationFunction<ListCellMoveCardMutation, ListCellMoveCardMutationVariables>;

/**
 * __useListCellMoveCardMutation__
 *
 * To run a mutation, you first call `useListCellMoveCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListCellMoveCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listCellMoveCardMutation, { data, loading, error }] = useListCellMoveCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      listId: // value for 'listId'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useListCellMoveCardMutation(baseOptions?: Apollo.MutationHookOptions<ListCellMoveCardMutation, ListCellMoveCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListCellMoveCardMutation, ListCellMoveCardMutationVariables>(ListCellMoveCardDocument, options);
      }
export type ListCellMoveCardMutationHookResult = ReturnType<typeof useListCellMoveCardMutation>;
export type ListCellMoveCardMutationResult = Apollo.MutationResult<ListCellMoveCardMutation>;
export type ListCellMoveCardMutationOptions = Apollo.BaseMutationOptions<ListCellMoveCardMutation, ListCellMoveCardMutationVariables>;